var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69478 14.0039L0.493408 12.5039L2.69478 10.302V14.0039Z",
    fill: "#2B2F38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45264 1.00658V15.2016C4.45264 15.2016 11.9151 20.2851 11.9151 20.2852C13.9437 21.6574 16.653 21.6275 18.6552 20.2107L25.5476 15.3305V1.00658C25.5476 0.450645 25.0969 0 24.541 0H5.45922C4.90328 0 4.45264 0.450645 4.45264 1.00658ZM21.8146 13.8363H8.21107C7.73811 13.8363 7.331 13.473 7.30838 13.0006C7.28424 12.4959 7.68619 12.0785 8.18623 12.0785H21.7895C22.2626 12.0785 22.6698 12.4418 22.6925 12.9144C22.7165 13.4191 22.314 13.8363 21.8146 13.8363ZM21.8146 9.22441H8.21078C7.73729 9.22441 7.33012 8.8602 7.30832 8.38723C7.28506 7.8825 7.68672 7.4666 8.18629 7.4666H21.7896C22.2627 7.4666 22.6699 7.82988 22.6925 8.30244C22.7165 8.80717 22.314 9.22441 21.8146 9.22441ZM21.8146 4.61191H8.21107C7.73811 4.61191 7.331 4.24863 7.30838 3.77619C7.28424 3.27146 7.68619 2.8541 8.18623 2.8541H21.7898C22.2634 2.8541 22.6707 3.21832 22.6925 3.69141C22.7157 4.19607 22.3135 4.61191 21.8146 4.61191Z",
    fill: "#2B2F38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5206 12.5174L27.3052 14.0859V10.302L29.5206 12.5174Z",
    fill: "#2B2F38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14.332V28.6969C30 29.4166 29.4166 30 28.6969 30H1.30313C0.583418 30 0 29.4166 0 28.6969V14.2951L9.50449 20.7697L4.02639 26.2478C3.6934 26.5808 3.66023 27.1226 3.97447 27.4734C4.31186 27.85 4.89498 27.8654 5.25117 27.5092L10.984 21.7764C13.7254 23.57 17.0338 23.398 19.476 21.7776L25.2076 27.5092C25.5505 27.8521 26.1073 27.8523 26.4504 27.5092C26.7938 27.1659 26.7938 26.6092 26.4504 26.2659L20.9344 20.7504L30 14.332Z",
    fill: "#2B2F38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.1dc5f4d1e149c41ce1c25babd83a36f2.svg";
export { ForwardRef as ReactComponent };